import { Grid } from "@mui/material";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import { renewToken } from "components/common/HandleApiFailure";
import Typography from "components/common/Typography";
import Dropdown from "components/common/dropdowns/DropDown";
import jwtDecode from "jwt-decode";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { persistor } from "redux/store";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";
import { manageStateRoleToDisplayValue } from "utils/CommonConstants";
import { encrypt } from "utils/CommonFunctions";
import { setOpenManageEstateRoleDialog } from "../dashboard/Dashboard.slice";
import { patchAssociatesMetadata } from "../dashboard/HotelUserDashboard.slice";
import "./index.scss";

const ManageEstateRoleDialog = () => {
  const isDialogOpen: any = useAppSelector((state) => state?.Dashboard.shouldShowManageEstateRoleDiaog);
  const dispatch = useAppDispatch();
  const [manageStateRole, setMSanageStateRole] = useState<string>("");
  const loggedInUserInfo = useAppSelector((state) => state.app.userName);
  const handleClose = () => {
    dispatch(setOpenManageEstateRoleDialog(false));
  };
  return (
    <div>
      {isDialogOpen && (
        <DialogFormation
          openDialog={isDialogOpen}
          parentOverflow={true}
          contentClass="manage-estate-role"
          handleClose={() => {
            handleClose();
          }}
          title="Select Default Role"
          actionConfig={
            <div className="modal-config-wrapper">
              <Button
                label="Cancel"
                onClick={() => {
                  handleClose();
                }}
                variant="secondary"
              />
              <Button
                label="Save"
                onClick={async () => {
                  await dispatch(
                    patchAssociatesMetadata({
                      payload: { manageEstateUserProfileMode: manageStateRole },
                      update_type: "manageEstatUserProfileRole"
                    })
                  );
                  const response: any = await renewToken();
                  const { access_token, refresh_token } = response.data;
                  const decoded: any = jwtDecode(access_token);
                  if (access_token) localStorage.setItem("id_token", access_token);
                  if (refresh_token) localStorage.setItem("refresh_token", refresh_token);
                  localStorage.setItem("manageEstateChangeRole", manageStateRole);
                  if (decoded["lobbyUserType"])
                    localStorage.setItem("lobbyUserType", encrypt("salt", decoded["lobbyUserType"]));
                  persistor.purge().then(() => window.location.replace("/"));
                }}
                variant="primary"
                disabled={
                  manageStateRoleToDisplayValue[loggedInUserInfo?.manageEstateUserProfileRole] === manageStateRole ||
                  loggedInUserInfo?.manageEstateUserProfileRole === manageStateRole
                }
              />
            </div>
          }
        >
          <div className="manage-estate-modal" style={{ position: "relative" }}>
            <div className="modal-wrapper">
              <div className="content-wrapper">
                <Grid className="heading">
                  <Typography variant="body2" showBold color={tokens.Text.General.PrimaryHeadline}>
                    Choose your default Role
                  </Typography>
                  <Typography variant={"body2"} color={colors.Neutral.Neutral400}>
                    The functionality and access will be based on your selected role
                  </Typography>
                </Grid>
                <div className="form-right">
                  <Dropdown
                    name="experienceLevel"
                    handleChangeUpdate={(val) => {
                      setMSanageStateRole(val);
                    }}
                    initialValue={manageStateRoleToDisplayValue[loggedInUserInfo?.manageEstateUserProfileRole]}
                    options={[
                      { id: "managed_estate", val: "Managed Estate" },
                      { id: "corporate", val: "Corporate" }
                    ]}
                    sx={{ margin: "4px 0px", "& .MuiSelect-select": { marginLeft: "11.43px" } }}
                  />
                </div>
              </div>
            </div>
          </div>
        </DialogFormation>
      )}
    </div>
  );
};

export default ManageEstateRoleDialog;
